export class HighlightStyle {
	BackgroundColor:string = "#00000000"
	Color:string = "#000000"

	public constructor(data?:any) {
		if (!data) return;

		this.BackgroundColor = data.BackgroundColor;
		this.Color = data.Color;
	}

	public getJSON(){
		return {
			BackgroundColor: this.BackgroundColor,
			Color: this.Color,
		};
	}

	public getStyle():any{
		return {
			backgroundColor: this.BackgroundColor,
			color: this.Color,
		};
	}
}